<template>
  <roe-modal wrap-class="header-actions-nav-dropdown-wrap" ref="dropDown">
    <div @click="changeModalState">
      <div v-if="num" class="header-actions-nav-dropdown">
        Step {{ num }} of 4<span></span>
      </div>
      <div class="header-actions-nav-dropdown-content">
        <div
          class="header-actions-nav-dropdown-line"
          :class="{ disabled: canGoToStepName('eligibility') }"
          @click="goToStep('eligibility')"
        >
          <div class="header-actions-nav-dropdown-step">STEP 1</div>
          <div class="header-actions-nav-dropdown-label">
            Current Plan Design
          </div>
        </div>
        <div
          class="header-actions-nav-dropdown-line"
          :class="{ disabled: canGoToStepName('load-data') }"
          @click="goToStep('load-data')"
        >
          <div class="header-actions-nav-dropdown-step">STEP 2</div>
          <div class="header-actions-nav-dropdown-label">Participant Data</div>
        </div>
        <div
          class="header-actions-nav-dropdown-line"
          :class="{ disabled: canGoToStepName('report-alternative-designs') }"
          @click="goToStep('report-alternative-designs')"
        >
          <div class="header-actions-nav-dropdown-step">STEP 3</div>
          <div class="header-actions-nav-dropdown-label">
            Model Alternative Designs
          </div>
        </div>
        <div
          class="header-actions-nav-dropdown-line"
          :class="{ disabled: canGoToStepName('report-download') }"
          @click="goToStep('report-download')"
        >
          <div class="header-actions-nav-dropdown-step">STEP 4</div>
          <div class="header-actions-nav-dropdown-label">Report</div>
        </div>
      </div>
    </div>
  </roe-modal>
</template>

<script>
import { mapGetters } from "vuex";
import { SHOW_FORM_ERRORS, HIDE_FORM_ERRORS } from "@/store/mutations.type";
import { GO_STEP } from "@/store/actions.type";
import RoeModal from "@/components/_shared/Modal";
export default {
  name: "RoeNavigationMenu",
  components: { RoeModal },
  props: {
    num: {
      type: Number,
      required: true
    },
    changeRoute: {
      type: Function,
      required: true
    },
    saveAction: {
      type: Function,
      required: false
    }
  },
  computed: {
    ...mapGetters(["invalidForm", "stepByStepName", "errorMessage"])
  },
  methods: {
    goToStep(stepName) {
      let step = this.stepByStepName(stepName);
      if (this.invalidForm) {
        this.$store.commit(SHOW_FORM_ERRORS);
        this.flashMessage.error({ title: "Error", message: this.errorMessage });
      } else if (this.$store.getters.canGoToStep(step)) {
        this.$store.commit(HIDE_FORM_ERRORS);
        if (this.saveAction) this.saveAction();
        this.$store.dispatch(GO_STEP, step);
        this.changeRoute();
      } else
        this.flashMessage.error({ title: "Error", message: this.errorMessage });
    },
    canGoToStepName(stepName) {
      let step = this.stepByStepName(stepName);
      return !this.$store.getters.canGoToStep(step);
    },
    changeModalState() {
      if (this.$refs.dropDown) {
        this.$forceUpdate();
        this.$refs.dropDown.changeState();
      }
    }
  }
};
</script>
